import { render } from "./FormProposal.vue?vue&type=template&id=ef39238e"
import script from "./FormProposal.vue?vue&type=script&lang=js"
export * from "./FormProposal.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__